import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { DebugEvent } from '@/lib/debug/types';
import { getApiDiagnostics } from '@/lib/api/diagnostics';

const RING_BUFFER_CAPACITY = 200;
const PERSIST_CAPACITY = 50;

const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

type DebugStoreState = {
  events: DebugEvent[];
  push: (event: DebugEvent) => void;
  clear: () => void;
  exportJson: () => string;
};

export const useDebugStore = create<DebugStoreState>()(
  persist(
    (set, get) => ({
      events: [],
      push: (event: DebugEvent) =>
        set(state => {
          const next = [...state.events, event];
          return {
            events: next.length > RING_BUFFER_CAPACITY ? next.slice(-RING_BUFFER_CAPACITY) : next,
          };
        }),
      clear: () => set({ events: [] }),
      exportJson: () =>
        JSON.stringify(
          {
            exportedAt: new Date().toISOString(),
            environment: getApiDiagnostics(),
            events: get().events,
          },
          null,
          2,
        ),
    }),
    {
      name: 'debug-store',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined' && window.localStorage ? window.localStorage : noopStorage,
      ),
      partialize: state => ({ events: state.events.slice(-PERSIST_CAPACITY) }),
    },
  ),
);
